export class AccountSource {
  static UNKNOWN_ERROR = 'Unknown';

  static CREATE_SOURCE = {
    'US_DEALER': 'Dealer Portal [Registration US]',
    'CA_DEALER': 'Dealer Portal [Registration CA]',
    'US_SELF_AZURE': 'One App [US]',
    'CA_SELF_AZURE': 'One App [CA]',
    'TC_AGENT': 'Agent Portal',
    '1A': 'One App'
  };
  /**
   * getSource get the source based on channel
   **/
  static getSource(channel: string): string {
    return !!this.CREATE_SOURCE[channel] ? this.CREATE_SOURCE[channel] : this.UNKNOWN_ERROR;
  }
  /**
   * getDate get the date in a UX format
   **/
  static getDate(date: any) {
    const parsedDate: Date = new Date(date * 1);
    const timeZone = parsedDate.toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2];
    return `${parsedDate.toLocaleString()} ${timeZone}`;
  }
}

